// These are the most simple getters,
// they will navigate the path, return the data found
// or default to null for null/undefined

export const selectSchedulerAllowCreation = ($) => $?.scheduler?.allowCreation ?? null;
export const selectSchedulerAllowModal = ($) => $?.scheduler?.allowModal ?? null;
export const selectSchedulerAppointmentDetails = ($) => $?.scheduler?.appointmentDetails ?? null;
export const selectSchedulerDayView = ($) => $?.scheduler?.dayView ?? null;
export const selectSchedulerProceduresDateIndex = ($) => $?.scheduler?.procedures_date_index ?? null;
export const selectSchedulerProcedures = ($) => $?.scheduler?.procedures ?? null;
export const selectSchedulerBookedByButton = ($) => $?.scheduler.bookedByButton ?? null;
export const selectSchedulerStylistId = ($) => $?.scheduler?.stylistId ?? null;
